import { Injectable } from '@angular/core';
import type * as XLSX from 'xlsx';

@Injectable({
  providedIn: 'root'
})
export class ExportExcelService {
  public async exportAsExcelFile(
    data: string[][],
    fileName: string
  ): Promise<void> {
    const XLSXlib = await import('xlsx');
    const ws: XLSX.WorkSheet = XLSXlib.utils.aoa_to_sheet(data);
    const wb: XLSX.WorkBook = XLSXlib.utils.book_new();

    // Tweek this logic if multiple sheets are needed
    XLSXlib.utils.book_append_sheet(wb, ws, 'Sheet1');

    XLSXlib.writeFile(wb, `${fileName}.xlsx`);
  }
}
